import Button from 'monday-ui-react-core/dist/Button';
import Icon from 'monday-ui-react-core/dist/Icon';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import Feedback from 'monday-ui-react-core/dist/icons/Feedback';

const billingFeedbackUrl = 'https://forms.monday.com/forms/9bd9ff76f2b0cfa599f525d4c1ed38ac?r=use1';

export default function FeedbackComponent() {
  const openFeedback = () => {
    window.open(billingFeedbackUrl, '_blank');
  };

  return (
    <div className="feedback-component">
      <Tooltip
        wrapperClassName="header-tooltip"
        content="Feedback"
        position="right"
        containerSelector=".header-component"
      >
        <Button kind={Button.kinds.TERTIARY} onClick={openFeedback}>
          <div className="button-content">
            <Icon iconType={Icon.type.SVG} icon={Feedback} iconSize={18} />
          </div>
        </Button>
      </Tooltip>
    </div>
  );
}
